import React, { useEffect, useState } from "react";
import FilmList from "./lists/FilmList";
import FilmBack from "./back/FilmBack";

function Films() {


    return (
        <section className="section_l">
            <div className="container_news">
                <h3 className="categorie">Films</h3>
                <div className="back">
                    <FilmBack />
                </div>
                <FilmList />
            </div>
        </section>
    )
}

export default Films;
